import listeningTogether from './listening-together.webp';
import forest from './forest.webp';
import familySmiling from './family-smiling.webp';
import guyListeningWithHeadphones from './guy-listening-headphones.webp';
import manListeningIntently from './man-listening-intently.webp';
import headphones from './headphones.webp';
import headphonesBlack from './headphones-black.webp';
import earCloseUp from './ear-close-up.webp';
import earWithSoundWaves from './ear-with-soundwaves.webp';
export var pageImages = {
    guyListeningWithHeadphones: guyListeningWithHeadphones,
    listeningTogether: listeningTogether,
    forest: forest,
    familySmiling: familySmiling,
    manListeningIntently: manListeningIntently,
    headphones: headphones,
    headphonesBlack: headphonesBlack,
    earCloseUp: earCloseUp,
    earWithSoundWaves: earWithSoundWaves,
};
